import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ReweighAppNotificationService } from '@shared/services/reweigh-app-notification.service';

/**
 * Dont use this, this is only as default error handler, error handling should be handled by ErrorHandlingService class
 */
@Injectable({
  providedIn: 'root',
})
export class ReweighDefaultErrorHandlerService implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(srcError: any): void {
    let lError: any = srcError;
    if (typeof srcError === 'function') {
      const calledSrcErrorRes = srcError.call(undefined);
      if (calledSrcErrorRes) {
        lError = calledSrcErrorRes;
      }
    }
    console.error('Default error handler->handleError: src, transformed:', srcError, lError);

    if (typeof (lError?.url ?? lError?.responseURL) === 'string' && (lError.url ?? lError.responseURL).toLowerCase().includes('token')) {
      return; // do not show token-related errors
    }

    const errorHandlingService: ReweighAppNotificationService = this.injector.get(ReweighAppNotificationService);
    // already logged below
    errorHandlingService.error(lError);
  }
}
